'use client';

import React from 'react';

import { cn } from '@/lib/utils/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  arrowIcon?: React.ReactNode;
  closeIcon?: React.ReactNode;
  isError?: boolean;
  iconClassName?: string;
  prefixinput?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      iconClassName,
      type,
      arrowIcon,
      closeIcon,
      isError,
      prefixinput,
      disabled,
      ...props
    },
    ref
  ) => {
    const [inputValue, setInputValue] = React.useState('');

    const handleClearInput = () => {
      if (!disabled) {
        setInputValue('');
      }
    };

    return (
      <div className='relative flex items-center w-full'>
        <input
          dir='rtl'
          lang='fa'
          inputMode='text'
          type={type}
          className={cn(
            `flex w-full text-xs rounded-md border border-border bg-background text-text ${
              !!arrowIcon ? 'px-8' : 'px-1'
            } ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-text placeholder:opacity-[0.3] placeholder:pr-[1px] focus:outline-none focus:ring-1 ${
              isError ? ' focus:ring-red-1' : 'focus:ring-blue-1'
            } hover:border-gray focus:border-transparent disabled:cursor-not-allowed disabled:bg-disableBg disabled:text-disableText disabled:border-disableBorder`,
            className
          )}
          ref={ref}
          value={inputValue}
          disabled={disabled}
          onChange={(e) => setInputValue(e.target.value)}
          {...props}
        />
        {arrowIcon && (
          <div
            className={`absolute inset-y-0 flex items-center pr-2.5 ${
              disabled ? 'pointer-events-none text-disableText' : 'text-text'
            } ${iconClassName}`}
          >
            {arrowIcon}
          </div>
        )}
        {closeIcon && (
          <div
            className={`absolute inset-y-0 left-1 flex items-center pr-2.5 ${
              disabled ? 'pointer-events-none text-disableText' : 'cursor-pointer text-text'
            }`}
            onClick={handleClearInput}
          >
            {closeIcon}
          </div>
        )}
        {prefixinput && (
          <div className={`absolute inset-y-0 left-1 flex items-center pr-2.5`}>{prefixinput}</div>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export { Input };
